import React from "react";

export const LineChart = ({ chartDots }) => {
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <svg
        width="860"
        height="232"
        viewBox="0 0 860 232"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Define Glow Effect */}
        <defs>
          <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="4" result="coloredBlur" />
            <feMerge>
              <feMergeNode in="coloredBlur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>

        {/* Glowing Line */}
        <polyline
          points={chartDots.join(" ")}
          stroke="white"
          fill="none"
          strokeWidth="2"
          filter="url(#glow)" // Apply glow filter
        />

        {/* Circle at the start of the line */}
        <circle
          cx={chartDots[0]}
          cy={chartDots[1]}
          r="2"
          stroke="white"
          fill="white"
        />
      </svg>
    </div>
  );
};
